import React, { useEffect, useState } from 'react';
import { ImageProps } from './types';
import styles from './Image.module.scss';
import cx from 'classnames';

const Image = React.forwardRef<HTMLImageElement, ImageProps>(
    (
        {
            src,
            placeHolderSrc,
            width,
            height,
            alt,
            className,
            maintainAspectRatio = false,
            ...restProps
        },
        ref,
    ) => {
        const { style } = restProps;
        const [imgSrc, setImgSrc] = useState(placeHolderSrc);
        const imageWidth = width ?? height;
        const imageHeight = height ?? width;

        useEffect(() => {
            const img = new window.Image();
            (img.src = src || ''),
                (img.onload = () => {
                    setImgSrc(src);
                });

            if (imgSrc !== src) setImgSrc(placeHolderSrc);
        }, [src]);

        const getDynamicStyles = () => {
            const dynamicStyles: React.CSSProperties = {};
            if (imageHeight) dynamicStyles.height = imageHeight;
            if (imageWidth) dynamicStyles.width = imageWidth;

            if (style) return { ...dynamicStyles, ...style };
            return dynamicStyles;
        };

        const imageLoaded = src === imgSrc;

        const imageStyle = cx(
            styles.image,
            { [styles['image--loading']]: !imageLoaded },
            { [styles['image--loaded']]: src && imageLoaded },
            { [styles['image--maintain-aspect-ratio']]: maintainAspectRatio },
            className,
        );

        const noSourceStyle = cx(styles.image, styles['image--no-source']);

        if (imgSrc)
            return (
                <img
                    className={imageStyle}
                    ref={ref}
                    style={getDynamicStyles()}
                    alt={alt}
                    src={imgSrc}
                    {...restProps}
                />
            );

        return (
            <div style={getDynamicStyles()} className={noSourceStyle}>
                <img alt={alt} />
            </div>
        );
    },
);

export default React.memo(Image);
